import { MasterDataScreen } from "@/screens";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/master-data/")({
  component: MasterDataScreen,
  loader: () => ({
    crumb: "Manajemen User",
  }),
});
